// extracted by mini-css-extract-plugin
module.exports = {"lazyLoader":"bg-z","hidden":"cg-z","preventTransition":"dg-z","divBgImg":"eg-z","loaded":"fg-z"};